
export type GetTermsLanguage = typeof GetTermsLanguage[keyof typeof GetTermsLanguage];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTermsLanguage = {
  ko: 'ko',
  en: 'en',
} as const;
